class SpektrixIframe {
    constructor(element) {
        this.element = element;
        this.iframe = element.querySelector("iframe");
        this.uid = this.iframe.dataset.iframeUid;
        this.loadingIndicator = element.querySelector(
            ".spektrix-iframe__loading-indicator",
        );

        this.iframe.addEventListener("load", () => {
            this.loaded();
        });

        if (this.iframe.readyState === "complete") {
            this.loaded();
        }

        // Add event listener for messages from the iframe
        window.addEventListener(
            "message",
            this.receiveMessage.bind(this),
            false,
        );

        window.spekShowViewFromSeat = function (url, tooltip) {
            if (!url.startsWith("http")) {
                url =
                    "https://sysfilessacbe149174fee.blob.core.windows.net/public-container/clients/selladoor/files/" +
                    url;
            }

            var image = $("<img />", {
                src: url,
            });

            $(".dialog-seat .dialog__content").html(image);

            $(".dialog-seat")
                .attr("open", "") // adds the open attribute
                .attr("aria-hidden", "false");

            $(document).on("click", "[data-dialog-close]", function () {
                $(".dialog-seat")
                    .removeAttr("open")
                    .attr("aria-hidden", "true");
            });
        };
    }

    loaded() {
        this.loadingIndicator &&
            this.loadingIndicator.setAttribute("active", false);
        this.iframe.classList.add("is-loaded");
    }

    receiveMessage(e) {
        if (typeof e.data !== "object" || !e.data.currentPage) {
            return;
        }

        const currentPage = e.data.currentPage;

        // Handle currentPage message
        if (currentPage) {
            if (currentPage.title) {
                // Alternative approach with more control:
                // Update all elements with data-spektrix-iframe-title attribute
                // document
                //     .querySelectorAll("[data-spektrix-iframe-title]")
                //     .forEach((element) => {
                //         element.textContent = displayTitle;
                //         element.dataset.spektrixIframeTitle = "loaded";
                //     });

                // Update the page-header heading element
                const h1 = document.querySelector(".page-header__heading");
                if (h1) h1.textContent = currentPage.title;
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".spektrix-iframe").forEach((element) => {
        new SpektrixIframe(element);
    });
});
